import { Box, Flex, FlexProps } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import OverflowingText from "../../../shared/OverflowingText"

export default function ArchivedIndicator({ ...props }: FlexProps) {
  const { t } = useBrandedTranslation()
  return (
    <Flex gap="2" alignItems="flex-start" justifyContent="flex-start" color="error" marginTop="1.5" {...props}>
      <Box as="span" minW="2" minH="2" borderRadius="50%" bgColor="error" marginTop="1" />
      <OverflowingText text={t("archiv-pdp-indicator-archiv")} noOfLines={3} fontSize="xs" textAlign="left" />
    </Flex>
  )
}
